import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { NamingPageService } from 'src/app/services/naming-page/naming-page.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
    public _pageName: string = '';

    constructor(
        public router: Router,
        private location: Location,
        private namingPage: NamingPageService
    ) {}

    ngOnInit(): void {
        this.namingPage
            .onPageNameChange()
            .subscribe((value) => (this._pageName = value));
    }

    back(): void {
        this.location.back();
    }
}
